import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { APPEARANCE_FONTS, APPEARANCE_PALETTES, AppearanceService } from '../../helpers/services/appearance.service';

@Component({
  selector: 'app-appearance-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: '<button mat-icon-button type="button" aria-label="Appearance" title="Appearance" (click)="open()"><mat-icon>palette</mat-icon></button>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppearanceButtonComponent {
  private readonly dialog = inject(MatDialog);
  private readonly appearance = inject(AppearanceService);
  open(): void {
    this.appearance.refresh();
    this.dialog.open(AppearanceDialogComponent, { width: '520px', maxWidth: '94vw', autoFocus: 'first-tabbable', ariaLabel: 'Appearance settings' });
  }
}

@Component({
  selector: 'app-appearance-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './appearance-button.component.html',
  styleUrls: ['./appearance-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppearanceDialogComponent {
  readonly appearance = inject(AppearanceService);
  readonly dialogRef = inject(MatDialogRef<AppearanceDialogComponent>);
  readonly palettes = APPEARANCE_PALETTES;
  readonly fonts = APPEARANCE_FONTS;
  readonly modes = [
    { id: 'light' as const, label: 'Light', icon: 'light_mode' },
    { id: 'dark' as const, label: 'Dark', icon: 'dark_mode' },
    { id: 'system' as const, label: 'Use device', icon: 'devices' },
  ];
}
